import { Injectable } from '@angular/core';
import { SimuladorGoApi } from '@gestor-web/@core/api/go';
import { RankingMedicosConsultasEletivas } from '@gestor-web/@core/api/ords/model';
import { map } from 'rxjs/operators';
import { FilterData } from '../../components/filtro/filtro.component';

const CD_CBO_GENERALISTA = '225170';

@Injectable()
export class RankingMedicosConsultasService {
  constructor(private simuladorGoApi: SimuladorGoApi) {}

  getData(
    regans: string,
    competenciaInicial: string,
    competenciaFinal: string,
    ano_realizacao: number,
    id_faixa_etaria: number,
    filtros: FilterData,
  ) {
    return this.simuladorGoApi
      .fetchRankingMedicosConsultasEletivas({
        regans,
        competencia: competenciaInicial,
        competencia_final: competenciaFinal,
        ano_realizacao,
        id_faixa_etaria,
        ...filtros,
      })
      .pipe(map(data => data.items));
  }

  getListagemGuias(
    regans: string,
    competenciaInicial: string,
    competenciaFinal: string,
    ano_realizacao: number,
    id_faixa_etaria: number,
    cd_guia_monitor: string,
    filtros: FilterData,
  ) {
    return this.simuladorGoApi
      .fetchRankingMedicosConsultasEletivasListaGuias({
        regans,
        competencia: competenciaInicial,
        competencia_final: competenciaFinal,
        ano_realizacao,
        id_faixa_etaria,
        cd_guia_monitor,
        ...filtros,
      })
      .pipe(map(data => data.items));
  }

  doVerificacao(items: RankingMedicosConsultasEletivas[]): RankingMedicosConsultasEletivasComVerificacao[] {
    return items.map(item => {
      const itemVerificado: RankingMedicosConsultasEletivasComVerificacao = {
        ...item,
        ds_verificacao: 'Sem médico identificado',
        id_verificacao: 0,
      };

      // Médico sem CBO
      if (!item.lt_cd_cbo_especialidade_medico_conselho) {
        return itemVerificado;
      }

      // Médico sem CBO na guia
      if (!item.lt_cd_cbo_exec_guias) {
        itemVerificado.ds_verificacao = 'Sem CBO na consulta';
        return itemVerificado;
      }

      const cdCboMedicoList = item.lt_cd_cbo_especialidade_medico_conselho.split('|');
      const cdCboGuiaList = item.lt_cd_cbo_exec_guias.split('|');
      // console.log('[Verificacao]', item.nm_medico, cdCboMedicoList, cdCboGuiaList);

      // Médico Generalista
      if (cdCboMedicoList.length == 1 && cdCboMedicoList[0] == CD_CBO_GENERALISTA) {
        // Existe guia de especialista
        if (cdCboGuiaList.filter(guiaCbo => guiaCbo != CD_CBO_GENERALISTA).length > 0) {
          itemVerificado.ds_verificacao = 'CBO de especialista na consulta para generalista';
          itemVerificado.id_verificacao = 2; // vermelho
          return itemVerificado;
        }

        itemVerificado.ds_verificacao = 'CBO da consulta compatível com a especialidade';
        return itemVerificado;
      }

      // Médico Especialista

      // Apenas guia generalista
      if (cdCboGuiaList.length == 1 && cdCboGuiaList[0] == CD_CBO_GENERALISTA) {
        itemVerificado.ds_verificacao = 'CBO de generalista na consulta para especialista';
        return itemVerificado;
      }

      // Existe guia de especialidade incompatível com a do médico
      const guiaIncompativel = cdCboGuiaList.find(
        guiaCbo => guiaCbo != CD_CBO_GENERALISTA && !cdCboMedicoList.includes(guiaCbo),
      );
      if (guiaIncompativel) {
        itemVerificado.ds_verificacao = 'CBO da consulta incompatível com a especialidade';
        itemVerificado.id_verificacao = 1;
        return itemVerificado;
      }

      // Guias de especialidade compatíveis com a do médico
      itemVerificado.ds_verificacao = 'CBO da consulta compatível com a especialidade';
      return itemVerificado;
    });
  }
}

export interface RankingMedicosConsultasEletivasComVerificacao extends RankingMedicosConsultasEletivas {
  ds_verificacao: string;
  id_verificacao: number;
}
